module.exports = __webpack_public_path__ + "static/media/eyelashes05.20e20dca.jpg";